import {
	MultiSelectGeneric,
	MultiSelectGenericProps,
} from './MultiSelectGeneric';
import { MultiSelectProps, SelectOption } from './SelectCommon';

export const MultiSelect = (props: MultiSelectProps<SelectOption>) => {
	const extendedProps: MultiSelectGenericProps<SelectOption> = {
		...props,
		getOptionValue: (item: SelectOption) => item.text,
		getOptionText: (item: SelectOption) => item.value,
	};

	return MultiSelectGeneric(extendedProps);
};
